import { render, staticRenderFns } from "./EditTestimonials.vue?vue&type=template&id=1d9bc567&scoped=true&"
import script from "./EditTestimonials.vue?vue&type=script&lang=js&"
export * from "./EditTestimonials.vue?vue&type=script&lang=js&"
import style0 from "./EditTestimonials.vue?vue&type=style&index=0&id=1d9bc567&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9bc567",
  null
  
)

export default component.exports